import React, { memo, useState } from 'react';
import { View, Pressable, Image, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';
import { SHADOW_STYLE } from './style';

import MenuItem from './menu_item';

export default memo(function PlusMenu(props) {
  const [mode, setMode] = useState('button');

  const handleAddPress = () => {
    if (props.onAddPress) {
      props.onAddPress();
      return;
    }
    setMode('menu');
  };

  const handleItemPress = (item) => {
    props.onItemPress(item);
    close();
  };

  const close = () => {
    setMode('button');
  };

  const renderItem = (item) => {
    return (
      <MenuItem key={item.id} item={item} onPress={handleItemPress} iconStyle={props.iconStyle} />
    );
  };

  if (mode === 'button' || !props.items) {
    return (
      <View style={styles.menuContainer}>
        <Pressable style={styles.menuButton} onPress={handleAddPress}>
          <Image
            style={styles.addIcon}
            source={require('../../../../resources/icon-add.png')}
            resizeMode="contain"
          />
        </Pressable>
      </View>
    );
  }
  return (
    <View style={styles.menuContainer}>
      <View style={styles.menuOpen}>{props.items.map((item) => renderItem(item))}</View>

      <Pressable style={styles.menuButton} onPress={close}>
        <Image
          style={styles.iconClose}
          source={require('../../../../resources/close-orange.png')}
          resizeMode="contain"
        />
      </Pressable>
    </View>
  );
});

const styles = StyleSheet.create({
  menuButton: {
    ...SHADOW_STYLE,
    width: 60,
    height: 60,
    borderRadius: 30,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
  },
  addIcon: {
    tintColor: COLOR.emphasis,
    width: 25,
    height: 25,
  },
  iconClose: {
    tintColor: COLOR.emphasis,
    width: 20,
    height: 20,
  },
  menuContainer: {
    position: 'absolute',
    right: 30,
    bottom: 30,
    alignItems: 'flex-end',
  },
  menuOpen: {
    ...SHADOW_STYLE,
    position: 'absolute',
    right: 30,
    bottom: 30,
    width: 250,
    borderRadius: 8,
    paddingBottom: 20,
    alignItems: 'flex-end',
    backgroundColor: COLOR.altContrast,
  },
});
